// extracted by mini-css-extract-plugin
export default {"tab_container":"styles_tab_container__LPDa6","tab_item":"styles_tab_item__sy9qd","active":"styles_active__LZ8JV"};